/* Free Shipping Progress Bar — works on any theme */
(function () {
  const THRESHOLD = 50; // £ threshold
  const BLUE = "#3b82f6";

  function pounds(cents) { return cents / 100; }

  function renderBar(total) {
    const wrapperId = "free-shipping-wrapper";
    const existing = document.getElementById(wrapperId);
    if (existing) existing.remove();

    const cartTotal = typeof total === "number" ? total : 0;
    const progress = Math.min(Math.max((cartTotal / THRESHOLD) * 100, 0), 100);
    const left = (THRESHOLD - cartTotal).toFixed(2);

    const html = `
      <div id="${wrapperId}" style="margin:12px 0;text-align:center;">
        <div style="
          position:relative;
          width:100%;
          background:#e5e7eb;
          border-radius:8px;
          height:10px;
          overflow:hidden;
          margin-bottom:10px;">
          <div style="
            position:absolute;
            left:0;top:0;
            height:100%;
            width:${progress}%;
            background:${BLUE};
            border-radius:8px;
            transition:width .4s ease;">
          </div>
        </div>
        ${
          cartTotal < THRESHOLD
            ? `<p style="font-weight:500;color:#1e293b;margin:0;">
                You’re £${left} away from free delivery.
               </p>`
            : `<p style="font-weight:500;color:#1e40af;margin:0;">
                🎉 You’ve unlocked free delivery!
               </p>`
        }
      </div>
    `;

    // Try to insert above checkout button
    const footer = document.querySelector(
      ".cart-drawer__footer, .drawer__footer, .mini-cart__footer, .cart__footer"
    );
    if (footer) {
      const checkoutBtn = footer.querySelector(
        'button[name="checkout"], [href="/checkout"], button[type="submit"]'
      );
      if (checkoutBtn) {
        checkoutBtn.insertAdjacentHTML("beforebegin", html);
      } else {
        footer.insertAdjacentHTML("afterbegin", html);
      }
    }
  }

  async function updateBar() {
    try {
      const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
      const cart = await res.json();
      renderBar(pounds(cart.total_price || 0));
    } catch (err) {
      console.warn("Free shipping bar failed:", err);
    }
  }

  // Observe drawer area for changes (theme-specific)
  function observeDrawer() {
    const drawer = document.querySelector(
      ".cart-drawer, .drawer--cart, .mini-cart, #CartDrawer"
    );
    if (!drawer) return;
    const mo = new MutationObserver(() => updateBar());
    mo.observe(drawer, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", () => {
    updateBar();
    observeDrawer();

    // also update on common triggers
    ["ajaxProduct:added", "cart:updated", "product:added", "cart-updated"].forEach(evt =>
      document.addEventListener(evt, updateBar)
    );

    // fallback: refresh when clicking qty or remove buttons
    document.body.addEventListener("click", e => {
      if (e.target.closest("[name='plus'], [name='minus'], .quantity__button, .cart-remove-button"))
        setTimeout(updateBar, 400);
    });
  });
})();
